import { renderRadioComponent } from '@ticketmaster/tm1pos-web-shared/components/RadioComponent';
import { PaymentType } from '@ticketmaster/tm1pos-web-shared/model/payment';
import { type PaymentMethod } from '@ticketmaster/tm1pos-web-shared/model/permissions';
import { type InjectedIntl, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form/immutable';
import messages from '../../../../messages';
import { CARD, OTHER, PIX } from '../../constants';
import { selectOtherPaymentMethods } from '../../selectors';

type PaymentTypeControlsProps = {
  intl: InjectedIntl;
  disableCard?: boolean;
  fieldName: string;
  paymentMethod: string;
};

const PaymentTypeControlsComponent = (props: PaymentTypeControlsProps) => {
  const otherPaymentMethods: PaymentMethod[] = useSelector(selectOtherPaymentMethods);
  const isPixAvailable = otherPaymentMethods.some((item) => item.type === PaymentType.PIX);

  const { intl, paymentMethod } = props;

  return (
    <ul className="oc-radio-list oc-radio-list--toggle checkout-payment-options">
      <li className="oc-radio-list__item">
        <Field
          name={props.fieldName}
          component={renderRadioComponent}
          id="creditCardRadio"
          value={CARD}
          text={intl.formatMessage(messages.checkoutCredit)}
          type="radio"
          checked={paymentMethod === CARD}
          disabled={props.disableCard}
        />
      </li>
      {isPixAvailable && (
        <li className="oc-radio-list__item">
          <Field
            name={props.fieldName}
            component={renderRadioComponent}
            id="pixRadio"
            value={PIX}
            text={intl.formatMessage(messages.checkoutPix)}
            type="radio"
            checked={paymentMethod === PIX}
          />
        </li>
      )}
      {otherPaymentMethods && otherPaymentMethods.filter((method) => method.type !== PaymentType.PIX).length > 0 ? (
        <li className="oc-radio-list__item">
          <Field
            name={props.fieldName}
            component={renderRadioComponent}
            id="otherRadio"
            value={OTHER}
            text={intl.formatMessage(messages.checkoutOther)}
            type="radio"
            checked={paymentMethod === OTHER}
          />
        </li>
      ) : null}
    </ul>
  );
};

export const PaymentTypeControls = injectIntl(PaymentTypeControlsComponent);
